import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AdminLogin from './components/AdminLogin';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import CompanySettings from './pages/CompanySettings';
import ServicesManager from './pages/ServicesManager';
import ProductsManager from './pages/ProductsManager';
import MediaCenter from './pages/MediaCenter';
import TestimonialsManager from './pages/TestimonialsManager';
import ContractAwardsManager from './pages/ContractAwardsManager';
import ProtectedRoute from './components/ProtectedRoute';

const AdminApp = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="company" element={<CompanySettings />} />
          <Route path="services" element={<ServicesManager />} />
          <Route path="products" element={<ProductsManager />} />
          <Route path="media" element={<MediaCenter />} />
          <Route path="testimonials" element={<TestimonialsManager />} />
          <Route path="awards" element={<ContractAwardsManager />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
};

export default AdminApp;